<script>
  export let isRecitating = false;
</script>

<style>
  svg {
    position: absolute;
    bottom: 0;
    left: 47%;
    width: 4vh;
    height: 4vh;
    margin-bottom: 2vh;
    cursor: pointer;
    fill: var(--color-grey);
    transition: fill 0.4s ease-in;
  }
  .active {
    fill: var(--color-bright);
  }
</style>

<svg on:click class:active={isRecitating} viewBox="0 0 45.974 45.975">
  <g>
    <path
      d="M9.629,44.68c-1.154,1.16-2.895,1.51-4.407,0.885c-1.513-0.623-2.5-2.1-2.5-3.735V4.043c0-1.637,0.987-3.112,2.5-3.736
      c1.513-0.625,3.253-0.275,4.407,0.885l17.862,17.951c2.088,2.098,2.088,5.488,0,7.585L9.629,44.68z" />
  </g>
  <g>
    <path
      d="M38.252,45.975c-2.763,0-5-2.238-5-5V5c0-2.762,2.237-5,5-5c2.762,0,5,2.238,5,5v35.975
      C43.252,43.736,41.013,45.975,38.252,45.975z" />
  </g>
</svg>
